import * as React from 'react';

interface IProps {
  className?: string;
}

export const Developer: React.FC<IProps> = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="80"
      height="80"
      fill="none"
      viewBox="0 0 80 80"
      className={className}
    >
      <path fill="#0468FF" fillOpacity="0.15" fillRule="evenodd" d="M64 8H24v16H0v56h64V8z" clipRule="evenodd" />
      <path fill="#0468FF" d="M24 64c0-13.255 10.745-24 24-24s24 10.745 24 24v8H24v-8z" />
      <path fill="#fff" fillRule="evenodd" d="M41 56V41h-2v17h18V41h-2v15H41z" clipRule="evenodd" />
      <rect width="64" height="8" x="16" y="72" fill="#0468FF" rx="4" />
      <path fill="#fff" d="M24 70H72V72H24z" />
    </svg>
  );
};
